var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('resource-index',{attrs:{"header":"Salesforce (Relatie) Contacten","endpoint":"accounts/contacts","show-route":"contacts.view"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }